import type React from 'react';

import type { IconProps } from 'types/icon';

const Star: React.FC<IconProps> = ({
  size = '16',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path d="M8 0.5L10.163 5.3735L15.5 5.9555L11.5 9.6265L12.489 14.9L8 12.3735L3.511 14.9L4.5 9.6265L0.5 5.9555L5.837 5.3735L8 0.5Z" />
    </svg>
  );
};

export default Star;
